import React from 'react';

export const Riley = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 235.14 497.91">
      <defs>
        <linearGradient
          id="linear-gradient"
          x1={127.33}
          x2={223.13}
          y1={464.22}
          y2={464.22}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#229da0" />
          <stop offset={1} stopColor="#87c0b8" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1={146.42}
          x2={146.17}
          y1={460.9}
          y2={449.62}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#c8d3cc" />
          <stop offset={0.04} stopColor="#cfd8d2" />
          <stop offset={0.16} stopColor="#e0e6e2" />
          <stop offset={0.31} stopColor="#ecefee" />
          <stop offset={0.51} stopColor="#f3f5f5" />
          <stop offset={1} stopColor="#f6f7f7" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1={171.82}
          x2={180.9}
          y1={454.73}
          y2={454.73}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#f6f7f7" />
          <stop offset={0.49} stopColor="#f3f5f5" />
          <stop offset={0.69} stopColor="#ecefee" />
          <stop offset={0.84} stopColor="#e0e6e2" />
          <stop offset={0.96} stopColor="#cfd8d2" />
          <stop offset={1} stopColor="#c8d3cc" />
        </linearGradient>
        <linearGradient
          xlinkHref="#linear-gradient-3"
          id="linear-gradient-4"
          x1={176.87}
          x2={185.95}
          y1={457.9}
          y2={457.9}
        />
        <linearGradient
          xlinkHref="#linear-gradient-3"
          id="linear-gradient-5"
          x1={182.52}
          x2={191.6}
          y1={460.52}
          y2={460.52}
        />
        <linearGradient
          xlinkHref="#linear-gradient-3"
          id="linear-gradient-6"
          x1={188.42}
          x2={197.51}
          y1={463.66}
          y2={463.66}
        />
        <linearGradient
          xlinkHref="#linear-gradient-2"
          id="linear-gradient-7"
          x1={125.91}
          x2={225.95}
          y1={487.72}
          y2={487.72}
        />
        <linearGradient
          id="linear-gradient-8"
          x1={145.87}
          x2={145.87}
          y1={449.72}
          y2={397.06}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#e79d61" />
          <stop offset={1} stopColor="#c07d42" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-9"
          x1={12.08}
          x2={107.88}
          y1={464.22}
          y2={464.22}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#87c0b8" />
          <stop offset={1} stopColor="#229da0" />
        </linearGradient>
        <linearGradient
          xlinkHref="#linear-gradient-2"
          id="linear-gradient-10"
          x1={763.07}
          x2={762.82}
          y1={460.9}
          y2={449.62}
          gradientTransform="matrix(-1 0 0 1 851.86 0)"
        />
        <linearGradient
          id="linear-gradient-11"
          x1={788.47}
          x2={797.55}
          y1={454.73}
          y2={454.73}
          gradientTransform="matrix(-1 0 0 1 851.86 0)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#f6f7f7" />
          <stop offset={0.49} stopColor="#f3f5f5" />
          <stop offset={0.69} stopColor="#ecefee" />
          <stop offset={0.84} stopColor="#e0e6e2" />
          <stop offset={0.96} stopColor="#cfd8d2" />
          <stop offset={1} stopColor="#c8d3cc" />
        </linearGradient>
        <linearGradient
          xlinkHref="#linear-gradient-11"
          id="linear-gradient-12"
          x1={793.52}
          x2={802.6}
          y1={457.9}
          y2={457.9}
        />
        <linearGradient
          xlinkHref="#linear-gradient-11"
          id="linear-gradient-13"
          x1={799.16}
          x2={808.25}
          y1={460.52}
          y2={460.52}
        />
        <linearGradient
          xlinkHref="#linear-gradient-11"
          id="linear-gradient-14"
          x1={805.07}
          x2={814.15}
          y1={463.66}
          y2={463.66}
        />
        <linearGradient
          xlinkHref="#linear-gradient-2"
          id="linear-gradient-15"
          x1={742.56}
          x2={842.59}
          y1={487.72}
          y2={487.72}
          gradientTransform="matrix(-1 0 0 1 851.86 0)"
        />
        <linearGradient
          xlinkHref="#linear-gradient-8"
          id="linear-gradient-16"
          x1={89.34}
          x2={89.34}
          y1={449.72}
          y2={397.06}
        />
        <linearGradient
          id="linear-gradient-17"
          x1={117.31}
          x2={117.31}
          y1={387.68}
          y2={332.97}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#5652a2" />
          <stop offset={1} stopColor="#454178" />
        </linearGradient>
        <linearGradient
          xlinkHref="#linear-gradient-8"
          id="linear-gradient-18"
          x1={37.53}
          x2={77.14}
          y1={324.91}
          y2={261.76}
        />
        <linearGradient
          id="linear-gradient-19"
          x1={30.75}
          x2={32.4}
          y1={334.29}
          y2={334.29}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#c58145" />
          <stop offset={1} stopColor="#583e26" />
        </linearGradient>
        <linearGradient
          xlinkHref="#linear-gradient-19"
          id="linear-gradient-20"
          x1={25.23}
          x2={27.07}
          y1={332.11}
          y2={332.11}
        />
        <linearGradient
          xlinkHref="#linear-gradient-19"
          id="linear-gradient-21"
          x1={21.15}
          x2={23.46}
          y1={329.23}
          y2={329.23}
        />
        <linearGradient
          xlinkHref="#linear-gradient-8"
          id="linear-gradient-22"
          x1={691.56}
          x2={731.17}
          y1={354.45}
          y2={291.31}
          gradientTransform="scale(-1 1) rotate(-6.17 4.713 8526.958)"
        />
        <linearGradient
          xlinkHref="#linear-gradient-19"
          id="linear-gradient-23"
          x1={683.36}
          x2={688.8}
          y1={367.4}
          y2={361.02}
          gradientTransform="scale(-1 1) rotate(-6.17 4.713 8526.958)"
        />
        <linearGradient
          xlinkHref="#linear-gradient-19"
          id="linear-gradient-24"
          x1={677.83}
          x2={682.85}
          y1={364.51}
          y2={358.62}
          gradientTransform="scale(-1 1) rotate(-6.17 4.713 8526.958)"
        />
        <linearGradient
          xlinkHref="#linear-gradient-19"
          id="linear-gradient-25"
          x1={673.85}
          x2={678.81}
          y1={361.54}
          y2={355.72}
          gradientTransform="scale(-1 1) rotate(-6.17 4.713 8526.958)"
        />
        <linearGradient
          id="linear-gradient-26"
          x1={40.34}
          x2={81.01}
          y1={268.85}
          y2={240.47}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#edd3e5" />
          <stop offset={1} stopColor="#d99bc5" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-27"
          x1={149.92}
          x2={187.02}
          y1={243.41}
          y2={243.41}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#d99bc5" />
          <stop offset={1} stopColor="#edd3e5" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-28"
          x1={120.25}
          x2={121.97}
          y1={212.52}
          y2={191.87}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#cd8b4d" />
          <stop offset={0.93} stopColor="#c07d42" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-29"
          x1={124.47}
          x2={117.26}
          y1={330.42}
          y2={194.6}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#edd3e5" />
          <stop offset={1} stopColor="#d99bc5" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-30"
          x1={195.04}
          x2={215.37}
          y1={139.25}
          y2={93.51}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#cd8b4d" />
          <stop offset={1} stopColor="#b77035" />
        </linearGradient>
        <linearGradient
          xlinkHref="#linear-gradient-28"
          id="linear-gradient-31"
          x1={110.33}
          x2={110.33}
          y1={190.84}
          y2={41.35}
        />
        <linearGradient
          id="linear-gradient-32"
          x1={136.16}
          x2={134.61}
          y1={114.99}
          y2={18.62}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.07} stopColor="#dc9458" />
          <stop offset={1} stopColor="#714e2f" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-33"
          x1={25.26}
          x2={89.16}
          y1={167.08}
          y2={54.59}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#bb7e4b" />
          <stop offset={1} stopColor="#875c37" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-34"
          x1={104}
          x2={94.89}
          y1={162.86}
          y2={72.3}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#dc9458" />
          <stop offset={1} stopColor="#714e2f" />
        </linearGradient>
        <linearGradient
          xlinkHref="#linear-gradient-32"
          id="linear-gradient-35"
          x1={147.38}
          x2={152.61}
          y1={143.3}
          y2={73.49}
        />
        <linearGradient
          id="linear-gradient-36"
          x1={181.29}
          x2={203.09}
          y1={178.55}
          y2={54.41}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ca8851" />
          <stop offset={1} stopColor="#714e2f" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-37"
          x1={127.4}
          x2={127.4}
          y1={153.8}
          y2={134.08}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.07} stopColor="#dc9458" />
          <stop offset={1} stopColor="#583e26" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-38"
          x1={62.86}
          x2={104.95}
          y1={122.87}
          y2={122.87}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#f6f7f7" />
          <stop offset={0.36} stopColor="#f3f4f4" />
          <stop offset={0.61} stopColor="#e9edeb" />
          <stop offset={0.83} stopColor="#dae1dd" />
          <stop offset={1} stopColor="#c8d3cc" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-39"
          x1={65.64}
          x2={82.52}
          y1={122.87}
          y2={117.98}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#676eaa" stopOpacity={0.1} />
          <stop offset={0.28} stopColor="#616aa4" stopOpacity={0.15} />
          <stop offset={0.53} stopColor="#505f93" stopOpacity={0.32} />
          <stop offset={0.76} stopColor="#344c76" stopOpacity={0.6} />
          <stop offset={0.99} stopColor="#0c324d" stopOpacity={0.98} />
          <stop offset={1} stopColor="#0b314c" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-40"
          x1={71.92}
          x2={95.73}
          y1={122.81}
          y2={122.81}
          gradientTransform="rotate(88.32 83.818 122.812)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#209c9f" />
          <stop offset={1} stopColor="#8cc4bd" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-41"
          x1={92.16}
          x2={75.52}
          y1={114.35}
          y2={131.24}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.15} stopColor="#573e26" stopOpacity={0} />
          <stop offset={1} stopColor="#184e5d" stopOpacity={0.91} />
        </linearGradient>
        <linearGradient
          id="linear-gradient-42"
          x1={861.68}
          x2={864.4}
          y1={-182.21}
          y2={-182.21}
          gradientTransform="rotate(-.43 41352.088 104715.622)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#f6f7f7" />
          <stop offset={0.79} stopColor="#c8d3cc" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-43"
          x1={871.72}
          x2={876.95}
          y1={-185.54}
          y2={-189.96}
          gradientTransform="rotate(-.43 41352.088 104715.622)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.83} stopColor="#c8d3cc" />
        </linearGradient>
        <linearGradient xlinkHref="#linear-gradient-38" id="linear-gradient-44" x1={140.59} x2={182.68} />
        <linearGradient xlinkHref="#linear-gradient-39" id="linear-gradient-45" x1={143.37} x2={160.25} y2={117.98} />
        <linearGradient
          xlinkHref="#linear-gradient-40"
          id="linear-gradient-46"
          x1={148.45}
          x2={172.26}
          gradientTransform="rotate(88.32 160.356 122.818)"
        />
        <linearGradient
          xlinkHref="#linear-gradient-41"
          id="linear-gradient-47"
          x1={168.69}
          x2={152.05}
          y1={114.35}
          y2={131.24}
        />
        <linearGradient
          xlinkHref="#linear-gradient-42"
          id="linear-gradient-48"
          x1={938.21}
          x2={940.93}
          y1={-181.63}
          y2={-181.63}
        />
        <linearGradient
          id="linear-gradient-49"
          x1={948.25}
          x2={953.48}
          y1={-184.96}
          y2={-189.38}
          gradientTransform="rotate(-.43 41352.088 104715.622)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={0.83} stopColor="#c8d3cc" />
        </linearGradient>
        <linearGradient
          xlinkHref="#linear-gradient-30"
          id="linear-gradient-50"
          x1={24.64}
          x2={18.22}
          y1={144.47}
          y2={120.08}
        />
        <linearGradient
          id="linear-gradient-51"
          x1={93.48}
          x2={114.75}
          y1={114.53}
          y2={-17.52}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#229da0" />
          <stop offset={1} stopColor="#a8dad9" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-52"
          x1={81.97}
          x2={167.25}
          y1={131.24}
          y2={63.79}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#8cc4bd" />
          <stop offset={1} stopColor="#209c9f" />
        </linearGradient>
        <linearGradient
          xlinkHref="#linear-gradient-52"
          id="linear-gradient-53"
          x1={67.46}
          x2={165.67}
          y1={87.59}
          y2={66.27}
        />
        <linearGradient
          id="linear-gradient-54"
          x1={141.71}
          x2={283.52}
          y1={41.51}
          y2={124.39}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#dd5c39" />
          <stop offset={0.19} stopColor="#e26936" />
          <stop offset={0.71} stopColor="#f18b2e" />
          <stop offset={1} stopColor="#f7982c" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-55"
          x1={141.71}
          x2={283.52}
          y1={41.51}
          y2={124.39}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#357e85" />
          <stop offset={1} stopColor="#00273b" />
        </linearGradient>
        <linearGradient
          xlinkHref="#linear-gradient-52"
          id="linear-gradient-56"
          x1={21.48}
          x2={87.6}
          y1={108.28}
          y2={54.74}
        />
        <linearGradient
          id="linear-gradient-57"
          x1={129.07}
          x2={127.45}
          y1={136.04}
          y2={133.04}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.01} stopColor="#fff" stopOpacity={0.8} />
          <stop offset={0.13} stopColor="#fdfdfd" stopOpacity={0.78} />
          <stop offset={0.28} stopColor="#f8faf9" stopOpacity={0.72} />
          <stop offset={0.44} stopColor="#f1f4f2" stopOpacity={0.63} />
          <stop offset={0.62} stopColor="#e6ebe8" stopOpacity={0.49} />
          <stop offset={0.8} stopColor="#d9e1dc" stopOpacity={0.32} />
          <stop offset={0.98} stopColor="#c9d4cd" stopOpacity={0.12} />
          <stop offset={1} stopColor="#c8d3cc" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient
          id="linear-gradient-58"
          x1={115.49}
          x2={139.31}
          y1={140.22}
          y2={140.22}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#976538" />
          <stop offset={1} stopColor="#583e26" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-59"
          x1={126.76}
          x2={126.69}
          y1={172.27}
          y2={167.69}
          gradientTransform="matrix(1.0993 .03935 -.03577 .99936 -6.22 -4.66)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#c58145" />
          <stop offset={1} stopColor="#583e26" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-60"
          x1={104.24}
          x2={150.81}
          y1={160.24}
          y2={151.6}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#a86f3d" />
          <stop offset={0.13} stopColor="#936237" />
          <stop offset={0.33} stopColor="#79522f" />
          <stop offset={0.54} stopColor="#66472a" />
          <stop offset={0.76} stopColor="#5b4027" />
          <stop offset={1} stopColor="#583e26" />
        </linearGradient>
        <style>
          {
            '.cls-13{fill:#6c4e33}.cls-14{fill:#a91d6e}.cls-18{fill:#573e26}.cls-20{fill:#583e26}.cls-21,.cls-22{fill:#301e10;mix-blend-mode:multiply}.cls-22{fill:#072f33}.cls-31{opacity:.15}'
          }
        </style>
      </defs>
      <g
        style={{
          isolation: 'isolate',
        }}
      >
        <g id="Feet">
          <path
            d="M223.13 480.41c-7.44.39-18.93 4.02-27.39 5.33-9.93 1.54-30.38.85-47.84-2.06-11.49-1.91-17.68-4.57-20.57-6.16 1.44-10.21 3.51-23.29 5.08-26.27 2.65-5.05 7.36-4.45 7.36-4.45s.17.02.5.05c1.79.18 8.18.74 14.07.56.38-1.35 4.69-3.6 6.71-4.62 6.33-3.2 7.31 2.9 14.77 9.14 9.09 6.68 26.34 13.37 36.78 15.41 7.88 1.54 10.53 9.33 10.53 13.07Z"
            style={{
              fill: 'url(#linear-gradient)',
            }}
          />
          <path
            d="M139.89 447.59h-1.96s-3.03 3.04-.27 8.47 9.42 4.91 12.38 2.52 4.38-9.19 5.73-10.99-15.87.34-15.87.34"
            style={{
              fill: 'url(#linear-gradient-2)',
            }}
          />
          <path
            d="m172.25 455.6 5.05-4.93a1.41 1.41 0 0 1 2.05.08l1.2 1.36c.5.57.46 1.44-.09 1.96l-4.98 4.74c-.54.51-1.39.52-1.94.01l-1.27-1.17c-.6-.55-.61-1.49-.03-2.05Z"
            style={{
              fill: 'url(#linear-gradient-3)',
            }}
          />
          <path
            d="m177.3 458.77 5.05-4.93a1.41 1.41 0 0 1 2.05.08l1.2 1.36c.5.57.46 1.44-.09 1.96l-4.98 4.74c-.54.51-1.39.52-1.94.01l-1.27-1.17c-.6-.55-.61-1.49-.03-2.05Z"
            style={{
              fill: 'url(#linear-gradient-4)',
            }}
          />
          <path
            d="m182.94 461.39 5.05-4.93a1.41 1.41 0 0 1 2.05.08l1.2 1.36c.5.57.46 1.44-.09 1.96l-4.98 4.74c-.54.51-1.39.52-1.94.01l-1.27-1.17c-.6-.55-.61-1.49-.03-2.05Z"
            style={{
              fill: 'url(#linear-gradient-5)',
            }}
          />
          <path
            d="m188.85 464.53 5.05-4.93a1.41 1.41 0 0 1 2.05.08l1.2 1.36c.5.57.46 1.44-.09 1.96l-4.98 4.74c-.54.51-1.39.52-1.94.01l-1.27-1.17c-.6-.55-.61-1.49-.03-2.05Z"
            style={{
              fill: 'url(#linear-gradient-6)',
            }}
          />
          <path
            d="M195.74 485.74c-9.93 1.54-30.38.86-47.84-2.05-11.49-1.92-17.68-4.57-20.57-6.16-.62 4.39-1.12 8.9-1.41 11.7-.16 1.57.91 2.99 2.47 3.24 8.12 1.34 33.17 5.11 60.33 5.43 33.29.4 37.13-4.97 37.21-7.36.04-1.13 0-3.76-1.02-8.49-.22-1-1.15-1.7-2.17-1.59-7.58.79-19.18 4.08-27 5.29Z"
            style={{
              fill: 'url(#linear-gradient-7)',
            }}
          />
          <path
            d="M158.91 418.41c-.27-6.68-1.29-28.12-1.29-28.12h-24.11s-1.77 16.33-.61 26.85c1.34 12.08 7.49 20.18 4.88 33.13.61 5.32 5.63 8.28 9.59 7.94 3.96-.34 6.09-5.67 7.3-8.56 1.13-2.68 3.29-5.03 4.57-5.73-.1-.73-.19-1.49-.23-2.01-.08-1.27.17-16.81-.1-23.5Z"
            style={{
              fill: 'url(#linear-gradient-8)',
            }}
          />
          <path
            d="M12.08 480.41c7.44.39 18.93 4.02 27.39 5.33 9.93 1.54 30.38.85 47.84-2.06 11.49-1.91 17.68-4.57 20.57-6.16-1.44-10.21-3.51-23.29-5.08-26.27-2.65-5.05-7.36-4.45-7.36-4.45s-.17.02-.5.05c-1.79.18-8.18.74-14.07.56-.38-1.35-4.69-3.6-6.71-4.62-6.33-3.2-7.31 2.9-14.77 9.14-9.09 6.68-26.34 13.37-36.78 15.41-7.88 1.54-10.53 9.33-10.53 13.07Z"
            style={{
              fill: 'url(#linear-gradient-9)',
            }}
          />
          <path
            d="M95.32 447.59h1.96s3.03 3.04.27 8.47-9.42 4.91-12.38 2.52-4.38-9.19-5.73-10.99 15.87.34 15.87.34"
            style={{
              fill: 'url(#linear-gradient-10)',
            }}
          />
          <path
            d="m62.96 455.6-5.05-4.93a1.41 1.41 0 0 0-2.05.08l-1.2 1.36c-.5.57-.46 1.44.09 1.96l4.98 4.74c.54.51 1.39.52 1.94.01l1.27-1.17c.6-.55.61-1.49.03-2.05Z"
            style={{
              fill: 'url(#linear-gradient-11)',
            }}
          />
          <path
            d="m57.91 458.77-5.05-4.93a1.41 1.41 0 0 0-2.05.08l-1.2 1.36c-.5.57-.46 1.44.09 1.96l4.98 4.74c.54.51 1.39.52 1.94.01l1.27-1.17c.6-.55.61-1.49.03-2.05Z"
            style={{
              fill: 'url(#linear-gradient-12)',
            }}
          />
          <path
            d="m52.26 461.39-5.05-4.93a1.41 1.41 0 0 0-2.05.08l-1.2 1.36c-.5.57-.46 1.44.09 1.96l4.98 4.74c.54.51 1.39.52 1.94.01l1.27-1.17c.6-.55.61-1.49.03-2.05Z"
            style={{
              fill: 'url(#linear-gradient-13)',
            }}
          />
          <path
            d="m46.36 464.53-5.05-4.93a1.41 1.41 0 0 0-2.05.08l-1.2 1.36c-.5.57-.46 1.44.09 1.96l4.98 4.74c.54.51 1.39.52 1.94.01l1.27-1.17c.6-.55.61-1.49.03-2.05Z"
            style={{
              fill: 'url(#linear-gradient-14)',
            }}
          />
          <path
            d="M39.47 485.74c9.93 1.54 30.38.86 47.84-2.05 11.49-1.92 17.68-4.57 20.57-6.16.62 4.39 1.12 8.9 1.41 11.7.16 1.57-.91 2.99-2.47 3.24-8.12 1.34-33.17 5.11-60.33 5.43-33.29.4-37.13-4.97-37.21-7.36-.04-1.13 0-3.76 1.02-8.49.22-1 1.15-1.7 2.17-1.59 7.58.79 19.18 4.08 27 5.29Z"
            style={{
              fill: 'url(#linear-gradient-15)',
            }}
          />
          <path
            d="M76.3 418.41c.27-6.68 1.29-28.12 1.29-28.12h24.11s1.77 16.33.61 26.85c-1.34 12.08-7.49 20.18-4.88 33.13-.61 5.32-5.63 8.28-9.59 7.94-3.96-.34-6.09-5.67-7.3-8.56-1.13-2.68-3.29-5.03-4.57-5.73.1-.73.19-1.49.23-2.01.08-1.27-.17-16.81.1-23.5Z"
            style={{
              fill: 'url(#linear-gradient-16)',
            }}
          />
        </g>
        <path
          id="Legs"
          d="M156.26 369.49c-.74-3.71-2.6-53.19-2.97-56.9l-70.1-1.7s-9.08 78.83-7.22 81.43c1.85 2.6 25.59 3.27 27.45 2.16.52-.95.92-19.04 1.66-21.27.74-2.23 10.39-38.57 13.35-40.43s10.76 36.35 12.24 40.06.37 21.14 1.11 22.63c.74 1.48 25.59.37 27.08-1.11.38-2.07-1.85-21.14-2.6-24.85Z"
          style={{
            fill: 'url(#linear-gradient-17)',
          }}
        />
        <g id="Hand">
          <path
            d="M37.11 292.21c5.93-15.14 13.15-25.65 15.6-28.55 1.51-1.78 4.55-10.86 4.55-10.86l19.73 13.46c-1.03 1.88-6.3 10.95-8.57 13.98s-12.97 18.38-12.97 18.38-3.78 5.88-3.5 8.04 3.65 6.03 3.78 11.14c.11 4.15.33 5.09 1.55 7.82s2.65 4.48 1.98 5.31c-1.3 1.61-4.46 1.71-6.53-1.02s-3.47-5.62-3.86-7.22c-1.32.28-7.78 5.05-8.9 7.22s-1.46 7-.98 8.22 3.04 3.76 2.65 5.82c-.32 1.69-2.13 2.98-3.63 1.85s-5.68-5.43-5.77-6.18c-2.16.19-4.8-1.32-5.27-2.45-1.41-.38-3.1-1.6-3.67-2.92-1.03.28-2.45-1.13-2.82-2.07s-2.25-7.21-1.44-10.98c.43-2.03 6.04-11.61 13.01-18.74 1.79-2.82 4.26-7.71 5.08-10.25Z"
            style={{
              fill: 'url(#linear-gradient-18)',
            }}
          />
          <path
            d="M31.4 329.35c-.29 1.2-.45 6.93.06 8.3.24.64.42 1.17.57 1.58"
            style={{
              stroke: 'url(#linear-gradient-19)',
              strokeWidth: '.75px',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              fill: 'none',
            }}
          />
          <path
            d="M25.66 327.5c0 .14-.42 5.46 1.03 9.24"
            style={{
              stroke: 'url(#linear-gradient-20)',
              strokeWidth: '.75px',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              fill: 'none',
            }}
          />
          <path
            d="M21.52 324.51s-.02 5.56 1.56 9.45"
            style={{
              stroke: 'url(#linear-gradient-21)',
              strokeWidth: '.75px',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              fill: 'none',
            }}
          />
          <path
            d="M194.71 295.47c-4.26-15.69-10.31-26.92-12.44-30.06-1.31-1.93-3.35-11.29-3.35-11.29l-21.06 11.26c.83 1.98 5.09 11.57 7.02 14.82 1.93 3.26 10.91 19.67 10.91 19.67s3.12 6.25 2.61 8.37-4.27 5.6-4.95 10.67c-.55 4.12-.87 5.03-2.38 7.61-1.51 2.58-3.12 4.17-2.54 5.06 1.12 1.74 4.25 2.18 6.6-.31s4.06-5.22 4.62-6.76c1.28.42 7.19 5.86 8.08 8.13s.69 7.11.1 8.28-3.43 3.41-3.26 5.5c.14 1.71 1.79 3.19 3.41 2.23s6.23-4.78 6.4-5.52c2.13.42 4.91-.79 5.5-1.86 1.44-.22 3.26-1.26 3.96-2.5 1 .39 2.55-.86 3.03-1.75s3.01-6.92 2.61-10.76c-.21-2.07-4.76-12.19-10.92-20.03-1.47-3-3.41-8.12-3.95-10.74Z"
            style={{
              fill: 'url(#linear-gradient-22)',
            }}
          />
          <path
            d="M196.1 332.98s.07 6.43-.66 8.28c-.73 1.85-1.18 2.23-1.18 2.23"
            style={{
              stroke: 'url(#linear-gradient-23)',
              strokeWidth: '.75px',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              fill: 'none',
            }}
          />
          <path
            d="M202.37 331.18c-.02.15-.19 6.48-2.39 10.08"
            style={{
              stroke: 'url(#linear-gradient-24)',
              strokeWidth: '.75px',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              fill: 'none',
            }}
          />
          <path
            d="M206.8 328.65s-.4 6.47-2.65 10.16"
            style={{
              strokeWidth: '.75px',
              stroke: 'url(#linear-gradient-25)',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              fill: 'none',
            }}
          />
          <path
            d="M80.84 210.9S53.47 249 52.71 250.01s4.04 12.38 12.13 17.94 15.04 2.98 15.04 2.98l8.62-10.47s-.34-43.75-7.66-49.56Z"
            style={{
              fill: 'url(#linear-gradient-26)',
            }}
          />
          <path
            d="M160.73 213.09s11 15.82 26.19 42.22c1.26 2.19-9.84 15.81-28.95 18.43l-8.06-12.24s2.73-46.65 10.81-48.41Z"
            style={{
              fill: 'url(#linear-gradient-27)',
            }}
          />
        </g>
        <g id="Body">
          <path
            d="M95.74 193.72s1.88-1.71 8.99-2.76 28.29-1.44 35.73 3.27c-14.52 17.59-20.29 17.94-20.29 17.94l-24.42-18.44Z"
            style={{
              fill: '#9b598e',
            }}
          />
          <path
            d="M109.68 189.12v10.3c0 3.82 1.93 7.38 5.14 9.45l1.53.99c3.35 2.17 7.61 2.41 11.18.61 3.84-1.93 6.24-5.86 6.21-10.15l-.09-11.69-23.96.48Z"
            style={{
              fill: 'url(#linear-gradient-28)',
            }}
          />
          <path
            d="M153.6 242.48c4.04-25.01 7.65-29 7.07-29.56-10.22-9.88-21.54-11.58-21.54-11.58l1.33-7.11-11.62 3.79-6.32 12.63-8.59-12.13s-17.18-5.05-18.19-4.8l1.5 6.85s-10.42 3.7-16.41 10.33c0 0 5.81 26.53 4.55 53.81-1.26 27.28-5.81 34.36-4.8 37.64 1.01 3.28 1.52 4.8 1.52 4.8l.66 5.7s12.98 4.04 40.76 4.04c19.24 0 27.49-2.04 28.55-2.36 2.06-.62 4.3-2.07 4.3-2.07.25-.76-1.01-6.32-1.01-6.32s1.13-1.97 1.52-3.03c.94-2.61-7.33-35.62-3.28-60.63Z"
            style={{
              fill: 'url(#linear-gradient-29)',
            }}
          />
          <path
            d="m127.16 198.74-6.01 12.39c-.16 34.76-.52 97.98-.8 100.35-.16 1.37-.32 1.93-.45 2.37-.19.66-.28 1.69-.28 3.01l1.96.02c0-1.08.08-1.91.23-2.41.14-.5.34-1.18.53-2.73.36-3.04.78-92.5.82-101.83l5.92-11.97-1.92.8Z"
            style={{
              fill: '#cc8dbc',
            }}
          />
        </g>
        <g id="Head">
          <path
            d="M197.78 103.06s14.43-4.82 18.85.43c4.43 5.25 1.48 31.53-21.4 35.11l2.55-35.54Z"
            style={{
              fill: 'url(#linear-gradient-30)',
            }}
          />
          <path
            d="M156.83 187.88c-23.01 6.14-25.78 8.42-31.32 8.87-6.89.56-11.74-2.68-20.62-3.64-19.72-2.13-45.73-7.21-62.47-24.98-.66-.7-1.46-1.51-2.35-2.43-.86-.87-1.8-1.85-2.81-2.93-7.39-7.93-18.41-21.79-23.72-45.22C9.77 60.8 59.7 32.73 85.63 26.97c25.93-5.76 119.76-7.1 121.63 72.04 1.87 79.14-44.26 87.23-50.43 88.87Z"
            style={{
              fill: 'url(#linear-gradient-31)',
            }}
          />
          <path d="m13.54 117.55 11.36 4.94.24-14.79-11.6 9.85z" className="cls-14" />
          <path d="m13.54 117.55 11.36 4.94.24-14.79-11.6 9.85z" className="cls-20" />
          <path
            d="M81.89 64.24S86 56.13 98.38 59.1s25.4 7.86 37.3 4.37c11.9-3.5 8.5-8.13 17.48-7.52s35.88 22.26 35.88 22.26-12.63-29.4-32.25-37.11c-19.62-7.71-66.35 5.77-66.35 5.77l-8.55 17.37Z"
            style={{
              fill: 'url(#linear-gradient-32)',
            }}
          />
          <path
            d="M42.54 138.61c-2.46 9.59-2.65 17.69-2.47 27.1-.86-.87-1.8-1.85-2.81-2.93-.02-2.91.03-6.02.17-9.34 1.51-37.13 12.12-53.81 12.12-53.81l13.3-4.36c-7.47 9.99-14.54 20.88-20.31 43.34Z"
            style={{
              fill: 'url(#linear-gradient-33)',
            }}
          />
          <path
            d="M85.39 92.03s21.55 8.49 16.99 38.13c14.58-13.96 4.37-32.67 4.37-32.67l-21.36-5.46Z"
            style={{
              fill: 'url(#linear-gradient-34)',
            }}
          />
          <path
            d="M164.6 90.31s-28.95 14.46-22.43 38.44c-12.17-15.8-.95-31.97-.95-31.97l23.37-6.47Z"
            style={{
              fill: 'url(#linear-gradient-35)',
            }}
          />
          <path
            d="M186.93 74.63s5.31 24.04 6.32 52.73c.45 12.91-1.85 37.65-1.85 37.65s5.21-7.2 6.7-10.68.25-51.89 0-53.88-5.71-23.84-5.71-23.84l-5.46-1.99Z"
            style={{
              fill: 'url(#linear-gradient-36)',
            }}
          />
          <path
            d="M137.38 32.22s-.03 0-.05.01"
            style={{
              strokeMiterlimit: 10,
              opacity: 0.58,
              stroke: '#231f20',
              fill: 'none',
            }}
          />
          <path d="M184.48 70.53s.15.54.4 1.54l-.72-.27.32-1.27Z" className="cls-14" />
          <path
            d="M207.31 132.82c-3.07 30.67-14.41 41.6-14.73 41.93h-.01c8.89-32.91-2.11-91.58-4.68-101.65l4.21 1.6 4.28 1.62 9.88 20.99s3.98 6.28 1.05 35.51ZM105.31 50.31s4.91 5.41 22.36 4.63c10.52-.47 29.02-4.93 29.02-4.93s-25.84-13.52-32.15-12.02-17.12 6.91-19.23 12.32Z"
            className="cls-13"
          />
          <path
            d="M201.12 132.48c-1.86 27.61-8.33 41.83-8.53 42.27h-.01c8.4-34.84-2.11-91.58-4.68-101.65l4.21 1.6 4.47 6.25s6.44 23.49 4.54 51.53Z"
            className="cls-20"
          />
          <path
            d="M66.22 96.86s6.27-7.13 13.98-6.27c7.7.86 21.21 10.91 26.81 8.78 2.66-1.01 1.7-4.01-.54-5.29-1.51-.86-13.16-5.49-17.72-7.48-4.56-2-9.19-1.78-12.9.22-3.71 2-8.77 7.19-9.63 10.05ZM183.31 96.1s-9.08-7.08-16.38-6.23c-7.31.86-20.12 10.91-25.44 8.78-2.52-1.01-1.62-4.01.51-5.29 1.43-.86 12.67-5.93 17.28-7.16 5.03-1.34 9.72-1.54 12.84-.09 3.67 1.71 9.01 6.78 11.19 9.98Z"
            className="cls-13"
          />
          <path
            d="M116.12 140.23c.83-2.21 8.66.38 12.83-.05s8.36-1.66 9.38-1.57c1.67.14-.3 10.04-8.92 10.78-8.27.72-14.71-5.36-13.29-9.16Z"
            style={{
              fill: 'url(#linear-gradient-37)',
            }}
          />
          <path
            d="M118.53 142.25c-.36-.43-.24-1.01.41-1.09s5.45 2.34 5.93 2.65-5.45-.47-6.34-1.56Z"
            className="cls-18"
          />
          <ellipse cx={83.9} cy={121.92} className="cls-21" rx={21.05} ry={14.68} />
          <ellipse
            cx={83.9}
            cy={122.87}
            rx={21.05}
            ry={13.73}
            style={{
              fill: 'url(#linear-gradient-38)',
            }}
          />
          <path
            d="M84.39 110.84c9.87 0 18.13 4.44 20.4 10.42-1.23-6.82-10.1-12.11-20.89-12.11-11.62 0-21.05 6.15-21.05 13.73 0 1.14.24 2.25.64 3.31-.1-.53-.16-1.07-.16-1.62 0-7.58 9.42-13.73 21.05-13.73Z"
            className="cls-31"
            style={{
              fill: 'url(#linear-gradient-39)',
            }}
          />
          <circle
            cx={83.82}
            cy={122.81}
            r={11.91}
            style={{
              fill: 'url(#linear-gradient-40)',
            }}
            transform="rotate(-88.32 83.826 122.81)"
          />
          <path
            d="M87.44 122.98a3.434 3.434 0 0 1-3.45-3.4c0-.56.14-1.09.38-1.56-.19-.02-.39-.06-.59-.05-2.67.02-4.82 2.2-4.8 4.88s2.2 4.82 4.88 4.8 4.82-2.2 4.8-4.88v-.04c-.38.15-.78.24-1.21.24Z"
            className="cls-22"
          />
          <path
            d="M77.94 128.78c-3.31-3.26-3.35-8.58-.09-11.89s8.58-3.35 11.89-.09a8.405 8.405 0 0 1 .09 11.89 8.405 8.405 0 0 1-11.89.09Z"
            style={{
              stroke: 'url(#linear-gradient-41)',
              strokeDasharray: '0 0 .41 .41',
              strokeWidth: '6.9px',
              strokeMiterlimit: 10,
              fill: 'none',
            }}
          />
          <circle
            cx={76.92}
            cy={124.53}
            r={1.36}
            style={{
              fill: 'url(#linear-gradient-42)',
            }}
          />
          <circle
            cx={87.46}
            cy={119.52}
            r={3.42}
            style={{
              fill: 'url(#linear-gradient-43)',
              opacity: 0.5,
            }}
          />
          <ellipse cx={161.63} cy={121.92} className="cls-21" rx={21.05} ry={14.68} />
          <ellipse
            cx={161.63}
            cy={122.87}
            rx={21.05}
            ry={13.73}
            style={{
              fill: 'url(#linear-gradient-44)',
            }}
          />
          <path
            d="M162.12 110.84c9.87 0 18.13 4.44 20.4 10.42-1.23-6.82-10.1-12.11-20.89-12.11-11.62 0-21.05 6.15-21.05 13.73 0 1.14.24 2.25.64 3.31-.1-.53-.16-1.07-.16-1.62 0-7.58 9.42-13.73 21.05-13.73Z"
            className="cls-31"
            style={{
              fill: 'url(#linear-gradient-45)',
            }}
          />
          <circle
            cx={160.35}
            cy={122.81}
            r={11.91}
            style={{
              fill: 'url(#linear-gradient-46)',
            }}
            transform="rotate(-88.32 160.359 122.81)"
          />
          <path
            d="M163.97 122.98a3.434 3.434 0 0 1-3.45-3.4c0-.56.14-1.09.38-1.56-.19-.02-.39-.06-.59-.05-2.67.02-4.82 2.2-4.8 4.88s2.2 4.82 4.88 4.8 4.82-2.2 4.8-4.88v-.04c-.38.15-.78.24-1.21.24Z"
            className="cls-22"
          />
          <path
            d="M154.48 128.78a8.405 8.405 0 0 1-.09-11.89 8.405 8.405 0 0 1 11.89-.09 8.405 8.405 0 0 1 .09 11.89 8.405 8.405 0 0 1-11.89.09Z"
            style={{
              strokeDasharray: '0 0 .41 .41',
              strokeWidth: '6.9px',
              stroke: 'url(#linear-gradient-47)',
              strokeMiterlimit: 10,
              fill: 'none',
            }}
          />
          <circle
            cx={153.45}
            cy={124.53}
            r={1.36}
            style={{
              fill: 'url(#linear-gradient-48)',
            }}
          />
          <circle
            cx={163.99}
            cy={119.52}
            r={3.42}
            style={{
              opacity: 0.5,
              fill: 'url(#linear-gradient-49)',
            }}
          />
          <path
            d="M31.7 121.52s-18.44-8.1-22.95-1.47.2 16.75 10.45 23.74c10.25 6.99 17.86 8.38 18.06 7.51.51-2.21-5.58-29.91-5.56-29.77Z"
            style={{
              fill: 'url(#linear-gradient-50)',
            }}
          />
          <path
            d="M40.4 135.73c-7.57 29.54 1.52 64.89 1.52 64.89-22.71-18.71-18.67-92.4-18.67-92.4 1.26-2.02 31.05-15.4 30.55-14.14-.12.3-.52 1.15-1.16 2.68-2.02 4.85-6.46 16.51-12.23 38.97Z"
            className="cls-13"
          />
          <path
            d="M41.92 200.62c-.24-.32-8.63-11.34-7.13-47.95 1.51-37.13 12.12-53.81 12.12-53.81l5.73-2.1c-2.02 4.85-6.46 16.51-12.23 38.97-7.57 29.54 1.52 64.89 1.52 64.89Z"
            className="cls-20"
          />
          <path
            d="M196.48 39.69C185.49 27.31 141.46-1.13 99.46.03 57.46 1.19 5.01 47.31.93 65.37c-4.4 19.5 7.97 43.97 11.9 51.06l3.45.8 19.22-10.07s10.79-40.84 65.51-65.89c54.71-25.05 102.9 11.81 102.9 11.81s-1.4-6.59-7.44-13.39Z"
            style={{
              fill: 'url(#linear-gradient-51)',
            }}
          />
          <path
            d="M234.49 85.2c-8.41-16.8-34.07-34.69-34.07-34.69s-26.22-20.12-63.09-18.28h-.05c-11.25.57-23.49 3.18-36.27 9.03-54.72 25.05-65.51 65.89-65.51 65.89s.02-.01.07-.02c1.03-.16 13.63-2.23 27.29-9.61 14.26-7.71 30.44-30.06 43.15-44.31 3.81-4.26 6.72-7.81 9.86-10.16.04-.02.08-.06.12-.09 10.97-8.75 27.06-17.5 71.33 4.08 20.01 9.75 36.24 28.99 45.98 44.99.68-1.12 2.95-3.31 1.19-6.83Z"
            style={{
              fill: 'url(#linear-gradient-52)',
            }}
          />
          <path
            d="M233.3 92.03c-9.74-16-25.97-35.24-45.98-44.99-44.27-21.58-60.36-12.83-71.33-4.08-.04.03-.08.07-.12.09-3.14 2.35-6.05 5.9-9.86 10.16-12.71 14.25-28.89 36.6-43.15 44.31-13.66 7.38-26.26 9.45-27.29 9.61 1.46-.52 25.01-8.89 38.08-22.33 13.47-13.86 29.18-48.45 63.63-52.57h.05c36.87-1.84 63.09 18.28 63.09 18.28s25.66 17.89 34.07 34.69c1.76 3.51-.51 5.71-1.19 6.83Z"
            style={{
              fill: 'url(#linear-gradient-53)',
            }}
          />
          <path
            d="M233.3 92.03c-4.09 6.95-21.15 9.44-26.13 9.11 0 0-15.61-29.05-50.68-48.71-24.44-13.7-33.15-14.85-40.5-9.47 10.97-8.75 27.06-17.5 71.33 4.08 20.01 9.75 36.24 28.99 45.98 44.99Z"
            style={{
              fill: 'url(#linear-gradient-54)',
            }}
          />
          <path
            d="M233.3 92.03c-4.09 6.95-21.15 9.44-26.13 9.11 0 0-15.61-29.05-50.68-48.71-24.44-13.7-33.15-14.85-40.5-9.47 10.97-8.75 27.06-17.5 71.33 4.08 20.01 9.75 36.24 28.99 45.98 44.99Z"
            style={{
              fill: 'url(#linear-gradient-55)',
            }}
          />
          <path
            d="M35.5 107.15c3.61-9.59 8.69-18.61 14.54-27.08 5.94-8.41 12.9-16.18 21-22.7.97-.86 2.09-1.54 3.13-2.32l3.18-2.25 3.36-1.99c1.13-.64 2.22-1.38 3.38-1.93 2.29-1.15 4.56-2.36 6.88-3.45l3.47-1.67 3.51-1.57c4.69-2.08 9.47-4 14.35-5.61 2.45-.79 4.91-1.52 7.42-2.11 2.5-.56 5.05-1.08 7.62-1.09-2.54.33-4.97 1.11-7.39 1.89-2.41.82-4.79 1.71-7.13 2.69-4.71 1.92-9.3 4.1-13.86 6.35-4.55 2.26-9.05 4.64-13.51 7.09-2.2 1.25-4.31 2.58-6.46 3.87l-3.05 2.21c-1 .76-2.07 1.42-3.01 2.26l-2.91 2.4c-.48.4-.98.79-1.45 1.21l-1.37 1.3-2.75 2.59c-.91.87-1.74 1.82-2.63 2.72-3.56 3.59-6.71 7.56-9.88 11.51-6.11 8.08-11.68 16.64-16.42 25.7Z"
            style={{
              fill: 'url(#linear-gradient-56)',
            }}
          />
          <ellipse
            cx={128.16}
            cy={134.35}
            rx={3.84}
            ry={2.25}
            style={{
              fill: 'url(#linear-gradient-57)',
            }}
          />
          <path
            d="M116.93 136.27s-3.18 4.48 2.12 6.52c5.3 2.04 15.53 2.49 18.29-.98s1.05-5.43-.47-5.74"
            style={{
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              fill: 'none',
              stroke: 'url(#linear-gradient-58)',
            }}
          />
          <path d="M132.26 143.73s3.58-4.45 4.88-3.75.41 1.95-.16 2.34-3.98 1.64-4.71 1.4Z" className="cls-18" />
          <path
            d="M106.71 151.56s-2.66.63-3.17 3.86c-1.51-1.81.7-4.25 3.17-3.86Z"
            style={{
              fill: '#a46d3c',
            }}
          />
          <path
            d="M119.28 168.46c1.85.6 8.02 2.24 14.68-.07.17-.06.34.12.22.26-3.78 4.39-11.83 3.92-15.11.08-.11-.13.04-.32.21-.26Z"
            style={{
              fill: 'url(#linear-gradient-59)',
            }}
          />
          <path
            d="M150.15 153.41c.15-.11.3-.21.45-.32l-.2-.27c-3.31 1.74-6.88 2.84-10.48 3.61-1.05.24-2.12.38-3.18.58-1.07.13-2.13.3-3.21.37-1.07.08-2.14.2-3.22.22l-1.61.06-1.61-.02c-4.3-.01-8.6-.51-12.81-1.47-3.58-.82-7.11-1.92-10.51-3.44l-.2.3c2.7 4.03 12.55 10 24.03 9.99 12.51-.42 18.37-5.75 22.79-9.36l-.16-.3s-.03.02-.09.05Z"
            style={{
              fill: 'url(#linear-gradient-60)',
            }}
          />
          <path
            d="M147.34 151.56s2.66.63 3.17 3.86c1.51-1.81-.7-4.25-3.17-3.86Z"
            style={{
              fill: '#593e26',
            }}
          />
          <path
            d="M127.34 161.2c9.16 0 16.97-2.91 20.08-7.01-2.43.98-4.95 1.69-7.49 2.23-1.05.24-2.12.38-3.18.58-1.07.13-2.13.3-3.21.37-1.07.08-2.14.2-3.22.22l-1.61.06-1.61-.02c-4.3-.01-8.6-.51-12.81-1.47-2.4-.55-4.78-1.24-7.11-2.08 3.06 4.16 10.92 7.12 20.16 7.12Z"
            style={{
              fill: '#fff',
            }}
          />
        </g>
      </g>
    </svg>
  );
};
export default Riley;
